import getSafeStorage from '@Helpers/getSafeStorage'
import { action, observable, toJS } from 'mobx'
import { BaseStore, getOrCreateStore } from '../di'

class SessionStore extends BaseStore {
  @observable session = null // Fields: session.data, session.error

  @action
  setSession = (session) => {
    this.session = session
  }

  getSession = () => {
    return toJS(this.session)
  }

  @action
  clear() {
    this.session = null
  }

  cleanSession = async (jwt) => {
    getSafeStorage('local').clear()
    getSafeStorage('session').clear()

    await this.request(
      {
        path: '/session',
        method: 'DELETE',
      },
      jwt
    )

    this.clear()
    window.location.reload()
  }
}

export default getOrCreateStore('SessionStore', SessionStore)
